import React, { useState } from "react";
import "../css/InvoiceAttachment.css";
import CustomButton from "../../common_component/component/CustomButton";
import { useUploadfile } from "../../_helper/actions/mutation/image";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import { getImageURLwithouttoken } from "../../_helper/utils/image";

const InvoiceAttachment = ({
  setIsUpload,
  setUploadedImageIds,
  uploadedImageIds,
}) => {
  const [selectedFiles, setSelectedFiles] = useState(uploadedImageIds);
  // const [uploadedImageIds, setUploadedImageIds] = useState([]);

  const handleFileSelect = (event) => {
    const files = event.target.files;
    setSelectedFiles([...selectedFiles, ...files]);
  };

  const handleDocumentClick = () => {
    document.getElementById("documentInput").click();
  };

  const handleImageClick = () => {
    document.getElementById("imageInput").click();
  };

  const handleRemoveFile = (fileName) => {
    const updatedFiles = selectedFiles.filter((file) => file.name !== fileName);
    const updatedUploadedFiles = uploadedImageIds?.filter(
      (file) => file?.name !== fileName
    );
    setUploadedImageIds(updatedUploadedFiles);
    setSelectedFiles(updatedFiles);
  };

  const truncateFileName = (fileName) => {
    const words = fileName.split(" ");
    if (words.length > 20) {
      return words.slice(0, 20).join(" ") + "...";
    }
    return fileName;
  };

  const uploadfileAndSubmit = useUploadfile({});

  const handleUpload = () => {
    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append("files", file);
    });

    uploadfileAndSubmit.mutate(formData, {
      onSuccess: (data) => {
        setIsUpload(false);
        let imageIds;
        if (data?.length > 0) {
          imageIds = data.map((file) => ({
            id: file?.id,
            name: file?.filename_download,
          }));
        } else {
          imageIds = [
            {
              id: data?.id,
              name: data?.filename_download,
            },
          ];
        }
        setUploadedImageIds(imageIds);
      },
    });
  };

  return (
    <div className="cu-invoice-attachment-cont">
      <div
        style={{ fontWeight: "bold", fontSize: "21px", cursor: "pointer" }}
        onClick={() => setIsUpload(false)}
      >
        x
      </div>
      <div className="cu-upload-invoice-icon-cont">
        <div onClick={handleDocumentClick}>
          <div>
            <img
              style={{ width: "55px", height: "60px" }}
              src={cufrontIcons.files}
              alt="..."
            />
          </div>
          <p>Document</p>
        </div>
        <div onClick={handleImageClick}>
          <div>
            <img
              style={{ width: "55px", height: "60px" }}
              src={cufrontIcons.gallery}
              alt="..."
            />
          </div>
          <p>Image</p>
        </div>
      </div>
      <input
        id="documentInput"
        type="file"
        accept=".pdf,.zip"
        multiple
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />
      <input
        id="imageInput"
        type="file"
        accept="image/*"
        multiple
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />
      <div className="cu-invoice-fileName-div">
        {selectedFiles.map((file, index) => (
          <div key={index}>
            <div>
              <a href={`${getImageURLwithouttoken(file?.id)}?download`} download={file.name}>
                {truncateFileName(file.name)}
              </a>
              {/* <span>{truncateFileName(file.name)}</span> */}
              <span
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => handleRemoveFile(file.name)}
              >
                x
              </span>
            </div>
          </div>
        ))}
      </div>
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <CustomButton
          style={{ width: "200px", height: "33px" }}
          className={"cu-invoice-attachment-btn"}
          onClick={handleUpload}
        >
          Upload
        </CustomButton>
      </div>
    </div>
  );
};

export default InvoiceAttachment;
